import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject } from 'rxjs';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { NextChapter, PreviousChapter } from 'src/app/story/state/chapters/story.chapters.actions';
import { ShowColumn } from '../../state/view.actions';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-view-chapters-drawer',
  templateUrl: './view-chapters-drawer.component.html',
  styleUrls: ['./view-chapters-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewChaptersDrawerComponent implements OnInit, OnDestroy {
  @Select(StoryChaptersState.getSelectedChapter)
  selectedChapter$: Observable<ChapterModel>;

  @Select(StoryChaptersState.getStoryChapters)
  storyChapters$: Observable<ChapterModel>;

  chapterIndex = 0;

  private ngUnsubscribe = new Subject();

  constructor(
    private store: Store
  ) { }

  ngOnInit() {
    this.selectedChapter$
      .pipe(
        filter(chapter => chapter != null),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((chapter) => {
        this.updateChapterIndex(chapter);
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    
  }

  handleChapterClick() {
    this.store.dispatch(new ShowColumn(true));
  }

  handlePreviousClick() {
    this.store.dispatch(new PreviousChapter());
  }

  handleNextClick() {
    this.store.dispatch(new NextChapter());
  }

  updateChapterIndex(chapter) {
    const chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
    this.chapterIndex = chapters.findIndex(_chapter => _chapter.id === chapter.id);
  }
}
